import { render, staticRenderFns } from "./ViewHospitalDoctor.vue?vue&type=template&id=1600f24c"
import script from "./ViewHospitalDoctor.vue?vue&type=script&lang=js"
export * from "./ViewHospitalDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports